export function queryReviewDestination(task, query, question) {
  const checklistId = Number(question?.checkListId || question?.checklistId);
  const questionId = Number(question?.id);
  const queryId = Number(query?.queryId || query?.id);
  if (!checklistId || !questionId || !queryId)
    throw new Error("The query's checklist question is unavailable. Refresh My Work and try again.");
  const params = new URLSearchParams({
    checklistId: String(checklistId),
    checklistName: question.checklistName || question.checkList?.name || question.checklist?.name || task.checklistName || "Checklist",
    questionId: String(questionId), queryId: String(queryId),
  });
  return `/inspectionreview/${task.inspectionId}/checklist?${params}`;
}
